import { render, staticRenderFns } from "./BtnUploadModelo.vue?vue&type=template&id=246ca655&"
import script from "./BtnUploadModelo.vue?vue&type=script&lang=js&"
export * from "./BtnUploadModelo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports